import React, { useState, createRef } from "react";

import { getCsrfCookieName } from "js/helpers/gazetteGetCsrfCookieName";
import { getCookie } from "js/helpers/gazetteGetCookie";

import colors from "core/colors";
import {
    NewsletterSubscription,
    NewsletterSubscriptionForm,
    NewsletterSubscriptionHeading,
    NewsletterSubscriptionSubmitBtn,
    NewsletterSubscriptionSuccessMessage
} from "./styles";

import CheckmarkCircleApprove from "core/jsSvgIcons/CheckmarkCircleApprove";
import FormInput from "core/FormInput";

export const NounGazetteSubscription = () => {
    const [inputValue, setInputValue] = useState("");

    const [subscriptionSuccessful, setSubscriptionSuccessful] = useState(false);
    const [requestSent, setRequestSent] = useState(false);

    const formRef = createRef();

    const sendRequest = async () => {
        const csrfCookieName = getCsrfCookieName();
        const csrftoken = getCookie({ name: csrfCookieName });

        let response = await fetch("/mailing-list/subscribe/", {
            method: "POST",
            headers: { "X-CSRFToken": csrftoken },
            // FormData object structure required by server
            // FormData needs reference to form element
            body: new FormData(formRef.current)
        });

        response = await response.json();
        return response;
    };

    const handleSubmit = async e => {
        e.preventDefault();

        const response = await sendRequest();
        setRequestSent(true);

        setSubscriptionSuccessful(response.success);
    };

    const successMessage = (
        <NewsletterSubscriptionSuccessMessage
            icon={CheckmarkCircleApprove}
            accentColor={colors.aquaGreen}
        >
            Thanks for subscribing!
        </NewsletterSubscriptionSuccessMessage>
    );

    const form = (
        <NewsletterSubscriptionForm ref={formRef} onSubmit={handleSubmit}>
            <FormInput
                onChange={setInputValue}
                value={inputValue}
                aria-label="Email address"
                type="email"
                placeholderAndLabel="Enter your email"
                width="13.375rem"
                inverse
                name="email"
                required
                size="medium"
            />
            <NewsletterSubscriptionSubmitBtn size="medium" type="submit">
                Submit
            </NewsletterSubscriptionSubmitBtn>
        </NewsletterSubscriptionForm>
    );

    return (
        <NewsletterSubscription>
            <NewsletterSubscriptionHeading>
                Subscribe to Noun Gazette
            </NewsletterSubscriptionHeading>
            {requestSent && subscriptionSuccessful ? successMessage : form}
        </NewsletterSubscription>
    );
};
